import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface MenuItem {
  id: string;
  label: string;
  url?: string;
  subMenu?: MenuItem[];
}

export interface Breadcrumb {
  label: string;
  url?: string;
}

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private breadcrumbsSubject = new BehaviorSubject<Breadcrumb[]>([]);
  breadcrumbs$ = this.breadcrumbsSubject.asObservable();

  private menu: MenuItem[] = [];

  constructor(private router: Router) {
    // Escucha cambios de navegación
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.updateBreadcrumb());
  }

  /** Carga el menú dinámico una vez el usuario inicia sesión */
  setMenu(menu: MenuItem[]) {
    this.menu = menu;
    this.updateBreadcrumb();
  }

  /** Busca el breadcrumb basado en la URL actual */
  private updateBreadcrumb() {
    const currentUrl = this.router.url.split('?')[0]; // ignora query params
    const breadcrumbs = this.findBreadcrumb(this.menu, currentUrl);
    this.breadcrumbsSubject.next(breadcrumbs);
  }

  /** Busca recursivamente el breadcrumb */
  private findBreadcrumb(menu: MenuItem[], url: string, parents: Breadcrumb[] = []): Breadcrumb[] {
    for (const item of menu) {
      const currentTrail = [...parents, { label: item.label, url: item.url }];
      if (item.url === url) return currentTrail;

      if (item.subMenu?.length) {
        const found = this.findBreadcrumb(item.subMenu, url, currentTrail);
        if (found.length) return found;
      }
    }
    return [];
  }
}
